import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';

import { getCurrentTier, getNextTier, getTierProgress } from './achievements';


const ProgressGauge = ({ value, tiers, unit }) => {
    const translate = useTranslate();

    const currentTier = getCurrentTier(value, tiers);
    const nextTier = getNextTier(value, tiers);
    const progress = getTierProgress(value, tiers);
    const fillColor = currentTier ? currentTier.style.color : '#5A6B6A';

    return (
        <Box>
            <Box
                sx={{
                    position: 'relative',
                    height: 10,
                    borderRadius: '5px',
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'dark'
                            ? 'rgba(26, 43, 46, 0.8)'
                            : 'rgba(0, 0, 0, 0.08)',
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        width: `${progress.percent}%`,
                        borderRadius: '5px',
                        background: `linear-gradient(90deg, ${fillColor}aa 0%, ${fillColor} 100%)`,
                        boxShadow: progress.isMaxed ? `0 0 12px ${fillColor}` : 'none',
                        transition: 'width 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                    }}
                />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.75 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    {progress.isMaxed ? (
                        <Box component="span" sx={{ color: fillColor, fontWeight: 700 }}>
                            ✦ {translate('Maximum level reached')}
                        </Box>
                    ) : (
                        <>
                            <Box component="span" sx={{ color: 'text.primary', fontWeight: 700 }}>
                                {value?.toLocaleString('fr-FR')}
                            </Box>
                            {' / '}
                            {nextTier?.threshold?.toLocaleString('fr-FR')} {unit}
                        </>
                    )}
                </Typography>
                {!progress.isMaxed && (
                    <Typography variant="caption" sx={{ color: fillColor, fontWeight: 700 }}>
                        {progress.percent}%
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default ProgressGauge;
